var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('CustomAlert',{attrs:{"id":"aa-alert"}}),(_vm.isLoggedIn)?_c('TopNav'):_vm._e(),_c('div',{staticClass:"main-content"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }